// # Expenses Tracking Component
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../../../auth/state';
import SharedHeader from '../../../../../components/SharedHeader';
import DashboardFooter from '../../../../../components/DashboardFooter';
import { FaFileInvoice, FaHistory, FaChartLine } from 'react-icons/fa';
import './expenses.css';

const ExpensesTracking = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAuthStore();

  // # Redirect if not admin
  React.useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);

  // # Expenses sections configuration
  const expensesSections = [
    {
      title: 'Register Expense',
      icon: <FaFileInvoice size={40} />,
      description: 'Record new expenses and transactions',
      path: '/admin/financial/expenses/register'
    },
    {
      title: 'Expenses History',
      icon: <FaHistory size={40} />,
      description: 'View and manage expense records',
      path: '/admin/financial/expenses/history'
    },
    {
      title: 'Expenses Analytics',
      icon: <FaChartLine size={40} />,
      description: 'Analyze expense trends and statistics',
      path: '/admin/financial/expenses/analytics'
    }
  ];

  return (
    <div className="expn_page">
      <SharedHeader />
      
      <main className="expn_content">
        <div className="expn_header">
          <h1>Expenses Tracking</h1>
          <button 
            className="expn_back-button"
            onClick={() => navigate('/admin/financial')}
          >
            Back to Financial System
          </button>
        </div>

        <div className="expn_sections-grid">
          {expensesSections.map((section, index) => (
            <div 
              key={index}
              className="expn_section-card"
              onClick={() => navigate(section.path)}
            >
              <div className="expn_card-icon">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter />
    </div>
  );
};

export default ExpensesTracking; 